module.exports = __webpack_public_path__ + "static/powerful-2e1f7cab8983a1e87d1d638804f7b8c9.svg";